import React from "react";
import PropTypes from "prop-types";
import { useContext } from "react";
import { ThemeContext } from "../../context";

const Map4dUIConfig = (props) => {
  const { config } = props
  const context = useContext(ThemeContext)
  let defaultConfig = JSON.parse(JSON.stringify(context))
  let newTheme = {
    ...defaultConfig,
    ...config || {}
  }
  return (
    <ThemeContext.Provider value={newTheme}>
      {props.children}
    </ThemeContext.Provider>
  )
};

Map4dUIConfig.propTypes = {
  config: PropTypes.object
};

export default Map4dUIConfig;
